import camelCase from 'lodash/camelCase';
export const _camelCase = camelCase;
